// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + "92a9614843dac7cfcb315036afeeb61f" + ".css";
};